import { ECatalogItem } from "./e-catalog-response";
import getStatusText from "./status";

const row = (timeFormat: string) => ({
    fileName,
    status,
    dateOfRequest,
    availability,
    downloadLink,
}: ECatalogItem): string => {
    const statusText = getStatusText(status);
    return `
        <tr>
            <td>${fileName}</td>
            <td>${statusText}</td>
            <td>
                <ux-date-time
                    utc="${dateOfRequest}"
                    format=${timeFormat}
                />
            </td>
            <td>${availability}</td>
            <td>
                ${
                    downloadLink !== ""
                        ? `<a
                        class="ux-button ux-button--icon-only"
                        href="${downloadLink}"
                        target="_blank"
                        download=""
                    >
                        <ux-icon name="download"></ux-icon>
                    </a>`
                        : `<ux-button size="icon" icon="download" disabled></ux-button>`
                }
            </td>
        </tr>
    `;
};

export default row;
